import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from "react-router-dom";

import useAddNCRoot from "../nav-control/hooks/useAddNCRoot";

import useTooltip from '../tooltip/hooks/useTooltip';
import Linkage from '../common/Linkage';

function Menu({ title, to, description, order }) {
  let match = useRouteMatch({ path: to, exact: false });
  useTooltip(`ref-${title}`, title, description);
  useAddNCRoot({ ref: `ref-${title}`, link: `link-ref-${title}`, action: `class`, scroll: true, type: `tabbar`, order })

  return (
    <div id={`ref-${title}`} className={`tab-bar-menu type-regular ${(match) && `select-menu`} `}>
      <Linkage label={title} to={to} className={``} linkClassName={`bp-link ${match ? `type-light` : `grey-1` }`} reportEnable={true} />
    </div>
  )
}

Menu.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  order: PropTypes.number.isRequired
}

export default Menu;
